import React from 'react'
import cicloImg from "../../images/EMPRESA.png"

import algarrobo from "../../images/Algarrobo.png"
import arboladoIcon from "../../images/proccess1.png"
import empresaIcon from "../../images/proccess2.png"
import productorIcon from "../../images/proccess3.png"
import ongIcon2 from "../../images/proccess5.png"

function Bosque() {
  return (
    <div className=''>
      <div className="p-5 forestBackground">
          <h1 className="pt-3 display-5 fw-bold text-light">Bosques Comunitarios</h1>
          <p className="pb-3 col-md-5 fs-2 text-light fw-light">Descubre como las especies del monte santiagueño y distintos actores de la sociedad combaten el cambio climático.</p>
      </div>

      <div className='px-4 py-2'>
         <h1 className="col-12 py-5 my-5 tittleText fw-bold">BOSQUE URBANO COMUNITARIO VIRTUAL</h1>
         <iframe src="https://www.google.com/maps/d/u/0/embed?mid=144rTmngYP-VQZYyySRscI0mIFes1oroS&ehbc=2E312F" width="100%" height="600px"></iframe>
      </div>

      <div className="d-flex flex-column flex-wrap py-5">
        
        <div className="col-12 d-flex flex-row text-center mb-5">
          <span className="col-4">
            <h1>01</h1>
            <span className="regularText grey fs-4">Instituciones evaluadas</span>
          </span>
          <span className="col-4">
            <h1>24</h1>
            <span className="regularText grey fs-4">Árboles nativos plantados en Santiago del Estero</span>
          </span>
          <span className="col-4">
            <h1>2 toneladas</h1>
            <span className="regularText grey fs-4">CO2 capturado</span>
          </span>
        </div>

        <div className="col-12 d-flex flex-row text-center mb-5 flex-wrap">
          <div className="d-flex flex-row col-12 col-md-4 military1Bg p-2 py-4">
              <span className="col-6">
                <h1 className="text-white">01</h1>
                <p className="text-white fs-4">Algarrobos</p>
              </span>
              <span className="col-6">
                <h1 className="text-white">01</h1>
                <p className="text-white fs-4">Quebrachos</p>
              </span>
          </div>
          <div className="d-flex flex-row col-12 col-md-4 military2Bg p-2 py-4">
            <span className="col-6">
              <h1 className="text-white">01</h1>
              <p className="text-white fs-4">Mistol</p>
            </span>
            <span className="col-6">
              <h1 className="text-white">01</h1>
              <p className="text-white fs-4">Chañar</p>
            </span>
          </div>
          <div className="d-flex flex-row col-12 col-md-4 military3Bg p-2 py-4">
            <span className="col-6">
              <h1 className="text-white">01</h1>
              <p className="text-white fs-4">Lapacho</p>
            </span>
            <span className="col-6">
              <h1 className="text-white">01</h1>
              <p className="text-white fs-4">Tipa</p>
            </span>
          </div>
        </div>



      </div>





      <div className='px-4 py-2 col-12 d-flex flex-column justify-content-center align-items-center'>
         <h1 className="col-12 py-5 mb-5 tittleText fw-bold">¿CÓMO FUNCIONA?</h1>
        <img src={cicloImg} alt="cicloImg" className='col-11 col-md-8 clickOver1'/>
     
        <div className="py-5 col-12 d-flex flex-column justify-content-center align-items-center py-4">
            <h1 className=" pt-5 tittleText fw-bold">Todos participamos</h1>
            <p className="grey fs-4">Creemos que el desarrollo sostenible viene de la mano con todos los sectores de la sociedad, por eso artículamos entre empresas, ONGs, productores y ciudadanos para disminuir las emisiones de Carbono.</p>
          
            <div className='d-flex flex-row flex-wrap justify-content-center align-items-center'>
              <div className="clickOver1 col-10 col-md-5">
                  <img className="d-md-block d-none" src={empresaIcon} alt="empresaIcon" width="400px"/>
                  <img className="d-md-none" src={empresaIcon} alt="empresaIcon" width="100%"/>
              </div>
              <div className="text-start col-10 col-md-7">
                <h1 className="military3">Empresas</h1>
                <p className="fs-4 grey">Disminuyen sus emisiones de Carbono (CO2) y aportes al Cambio Climático, obteniendo un perfil más verde y con responsabilidad social y ambiental.</p>
              </div>
            </div>

            <div className='d-flex flex-row flex-wrap justify-content-center align-items-center'>
              <span className='col-10 col-md-5 d-md-none'>
                 <img src={productorIcon} alt="productorIcon"  width="100%" className="clickOver1"/>
              </span>
              <span className="col-10 col-md-7 text-end">
                <h1 className="military3">Productor</h1>
                <p className="fs-4 grey">Produce plantines de árboles nativos, que son comprados por las empresas como método de compensación de emisiones. Generando ganancias para ambos.</p>
              </span>
              <span className='col-10 col-md-5 d-none d-md-block'>
                 <img src={productorIcon} alt="productorIcon"  width="400px" className="clickOver1"/>
              </span>
            </div>

            <div className='d-flex flex-row flex-wrap justify-content-center align-items-center'>
              <span className='col-10 col-md-5'>
                 <img className="clickOver1 d-none d-md-block" src={ongIcon2} alt="ongIcon2"  width="400px"/>
                 <img className="d-md-none" src={ongIcon2} alt="ongIcon2"  width="100%"/>
              </span>
              <span className="col-10 col-md-7 text-start">
                <h1 className="military2">ONG</h1>
                <p className="fs-4 grey">Recibe los plantines comprados, como donación de la empresa. Se encarga de intercambiarlos en "Eco-Canjes" por material para reciclar (botellas, carton, etc) que lleven las personas interesadas o a quienes tengan interés en plantar uno o varios árboles.</p>
              </span>
            </div>

            <div className='d-flex flex-row flex-wrap justify-content-center align-items-center'>
              <span className='col-10 col-md-5 d-md-none'>
                 <img className="clickOver1" src={arboladoIcon} alt="sociedadIcon" width="100%"/>
              </span>
              <span className="col-10 col-md-7 text-end">
                <h1 className="military2">Sociedad</h1>
                <p className="fs-4 grey">Quienes reciben los plantines, pasarán a componer el "Bosque Comunitario Virtual". Donde se registrará  el lugar y uso del plantín (arbolado urbano, reforestación, plantaciones productivas etc).</p>
              </span>
              <span className='col-10 col-md-5 d-none d-md-block'>
                 <img className="clickOver1" src={arboladoIcon} alt="sociedadIcon" width="400px"/>
              </span>
            </div>

          </div>



          <div className='d-flex flex-wrap justify-content-center align-items-center pt-5 mt-3'>
            <div className='text-center'>
              <p className="fs-4 p-5 mb-5 col-12 text-white greenTwoBackground">
              ¡Formando así un gran mapa en vivo de árboles que están creciendo, capturando Carbono y mitigando el Cambio climático en este mismo momento!
              </p>
            </div>
          </div>
     
      </div>

      <div>
        <div className="p-5 col-12 mt-5">
          <h1 className="tittleText fw-bold">¿CUÁNTO AYUDA UN ÁRBOL?</h1>
          <p className="grey fs-4">A medida que un árbol del bosque santiagueño crece, va almacenando Carbono que captura de atmósfera en su biomasa. Mientras mayor sea su tamaño, más ha almacenado. Por eso cuando plantamos y llevamos un registro del crecimiento de nuestros árboles, sabemos cuanto Carbono hemos capturado y nuestro aporte a combatir el Cambio Climático.</p>
       </div>
        <img src={algarrobo} alt="algarroboImg" width="100%" className=""/>
      </div>

    </div>
  )
}

export default Bosque